import Swiper from 'swiper/bundle';
import videojs from "video.js";

var categoryAttributes = $('.title-category').map(function () {
    return $(this).data('category');
}).get();

let videoSwiper;
let swiperVideoText;
let wWidth = $(window).width();
let videoInstance = null;

initializeSwipers();
$(window).on('resize', function () {
    if ($(window).width() !== wWidth) {
        wWidth = $(window).width();
        if (videoSwiper) {
            videoSwiper.destroy(true, true);
        }
        if (swiperVideoText) {
            swiperVideoText.destroy(true, true);
        }
        initializeSwipers();
    }
});

function initializeVideoInstance(index) {
    let videoSlide = $('.video-slider.swiper-container .swiper-slide').eq(index);
    let nthChild = index + 1;

    let videoBox = videoSlide.find('.video-js-box');

    if(videoInstance) {
        videoInstance.pause();
        videoInstance.dispose();
        videoInstance = null;
    }

    $('.video-slider.swiper-container .swiper-slide:not(:nth-child('+nthChild+')) .video-js-box').html('');

    if(videoBox.length > 0) {
        let videoFile = videoBox.data('video');
        let videoId = videoBox.attr('id');

        videoBox.html('<video preload="auto" id="video_'+videoId+'" class="video-js bg-img vjs-theme-revocit" autoplay muted loop playsinline data-setup=\'{"controls": false, "disablePictureInPicture" : true, "controlBar" : false }\'><source src="' + videoFile + '" type="video/mp4"></video>');
        videoInstance = videojs('video_'+videoId);
    }
}

function initializeSwipers() {

    videoSwiper = new Swiper(".video-slider.swiper-container", {
        spaceBetween: 40,
        slidesPerView: 1,
        loop: false,
        speed: 1000,
        updateOnWindowResize: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<div class="text-1 ' + className + '">' + (categoryAttributes[index]) + "</div>";
            },
        },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        breakpoints: {
            300: {
                spaceBetween: 8,
                autoplay: false,
            },
            768: {
                spaceBetween: 32,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                },
            },
            1024: {
                spaceBetween: 32,
            },
            1440: {
                spaceBetween: 40,
            },
        },
        on: {
            init: function (swiper) {
                initializeVideoInstance(0);
            },
            slideChange: function (swiper) {
                initializeVideoInstance(videoSwiper.activeIndex);
            }
        },
    });

    swiperVideoText = new Swiper(".video-text-slider.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: true,
        slideToClickedSlide: true,
        updateOnWindowResize: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        breakpoints: {
            768: {
                autoplay: false,
            },
        },
    });

    videoSwiper.on('slideChange', function () {
        if ($(window).width() > 767) return;
        swiperVideoText.slideTo(videoSwiper.activeIndex);
    });
    swiperVideoText.on('slideChange', function () {
        if ($(window).width() > 767) return;
        videoSwiper.slideTo(swiperVideoText.activeIndex);
    });
}